import { Link } from 'react-router-dom'

import React, { memo } from 'react'

import Message from '@Pure/Message'

const form_status =
[
	{ field: 'info', color: 'green', icon: 'checked' },
	{ field: 'warning', color: 'orange', icon: 'info' },
	{ field: 'error', color: 'red', icon: 'info' },
	{ field: 'statement', color: 'blue', icon: 'info' }
];

export default memo(function FormStatus (props)
{
	const status = form_status
	.filter(status_data => typeof props[status_data.field] !== 'undefined')
	.map(function (status_data, index)
	{
		return (
			<Message color={ status_data.color } icon={ status_data.icon }
				style={ props.style } key={ status_data.field }
				bemit={ props.bemit }>
				{ props[status_data.field] }
				{ props.children }
				{
					['FORBIDDEN', 'DENIED'].includes(props.ERROR_CODE) &&
						!props['hide-auto-msg'] ?
					(
						<>
							&nbsp;
							<Link to="/login">
								Page de connexion
							</Link>
						</>
					)
					: undefined
				}
			</Message>
		);
	});

	return status.length > 0
	? status
	: null;
});